import React, {useState, useRef, useEffect} from 'react';
import HistoryTable from './HistoryTable.mjs';
import HistoryFilters from './HistoryFilters.mjs';
import './Card.css';

const DEBUG = 0;

export default function UserHistoryCard({user_id}) 
{
    const [history_events, setHistoryEvents] = useState();
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const fetchRef = useRef("");

    const [show_filter_options, showFilterOptions] = useState(false);
    const [filter_form, setFilterForm] = useState("");

    var type = "get_user_history_events";
    var search_body = JSON.stringify({type, user_id});
 
    useEffect(() =>
    {
        if (!user_id) return;
        
        if (fetchRef.id == user_id) return;
        fetchRef.id = user_id;
  
        console.log(`UserHistoryCard - fetching User History Events from ctal-get for: ${user_id}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-get`, { method: "POST", body: search_body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: search_body })
            .then(response => response.json())
            .then(setHistoryEvents)
            .then(() => setLoading(false))
            .catch(setError);
    }, [user_id]);

    if (loading) return <h1>Loading User History Events...</h1>;
    if (error) return <pre>{JSON.stringify(error, null, 2)}</pre>
    if (!history_events) return null;
      
    const show_history_filters = () => {
        if (show_filter_options)
        {
            showFilterOptions(false);
            setFilterForm(<></>);
            return;
        }

        showFilterOptions(true);

        setFilterForm ( <> <HistoryFilters /> </> );
    } 

    if (DEBUG) return;

    return (
        <>
            <div class="card mt-2">
                <div id="user-history-card-header" class="card-header">
                    <div class="row">
                        <div id="user-history-title" class="col text-start">
                            <a href="#"><img class="card-icon" src="./images/history.svg" alt="history" border="0"/></a>
                            <span className="card-sub-title">User History</span>
                        </div>
                        <div class="col-2 text-end">

                        </div>
                    </div>
                    {filter_form}
                </div>
                <div class="card-body">
                    <HistoryTable history_events={history_events} />
                </div>
            </div>
        </>
    );
}

/*
    October 10, 2023 Remove History filter for v1.0
                            <a href="#"><img class="card-icon" src="./images/filter.svg" alt="filter" border="0" onClick={ show_history_filters }/></a>

*/